// Single source of truth for the canvas element and its 2D context.
// Everything that draws imports `ctx` from here instead of re-querying the DOM.

const element = document.querySelector('#game');

if (!(element instanceof HTMLCanvasElement)) {
  throw new Error('GORILLAS: canvas #game was not found in the document.');
}

export const canvas = element;
export let ctx = canvas.getContext('2d');

/**
 * Draws with a different surface for the length of one call.
 *
 * One thing in the game needs to paint somewhere else: the greeting puppets, which go
 * on a canvas that sits above the front end's cards. The game canvas is behind them, so
 * a puppet painted there is a puppet nobody can see — and borrowing the sprite code is
 * worth this much, because it is the same gorilla, in a species and accessories any
 * player could be wearing. ES modules hand out live bindings, so every `import { ctx }`
 * follows the swap and no drawing function has to be handed a pen.
 */
export function withCanvas(other, draw) {
  const mine = ctx;
  ctx = other;

  try {
    draw();
  } finally {
    ctx = mine;
  }
}

// Logical resolution. The canvas is scaled by CSS, all math uses these units.
export const W = canvas.width;
export const H = canvas.height;

// `roundRect` is not available in older Safari, so resolve it once at startup.
export const hasRR = !!ctx.roundRect;
